import { useId, useState } from 'react';
import { Info } from 'lucide-react';

export interface InfoContent {
  /** One plain sentence. */
  text: string;
  /** Where it lives in SAP Business One, in simple words. */
  sap?: string;
  /** "How this is calculated" in plain words. */
  formula?: string;
}

/** The "i" next to a KPI or card title: definition plus SAP source, on hover or focus. */
export function InfoTip({ info, label = 'About this number' }: { info: InfoContent; label?: string }) {
  const [open, setOpen] = useState(false);
  const id = useId();
  return (
    <span className="info" onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
      <button
        type="button"
        className="info-btn"
        aria-label={label}
        aria-describedby={open ? id : undefined}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        onClick={(e) => {
          e.stopPropagation();
          setOpen((o) => !o);
        }}
      >
        <Info size={14} strokeWidth={1.8} />
      </button>
      {open && (
        <span role="tooltip" id={id} className="tip">
          {info.text}
          {info.formula && (
            <span className="tip-sap" style={{ display: 'block' }}>
              <b>How this is calculated:</b> {info.formula}
            </span>
          )}
          {info.sap && (
            <span className="tip-sap" style={{ display: 'block' }}>
              <b>From SAP B1:</b> {info.sap}
            </span>
          )}
        </span>
      )}
    </span>
  );
}
